// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ClosuresPaymentList        = lazy(() => import('../../views/closures/payment/list'))
const ClosuresPaymentAdd         = lazy(() => import('../../views/closures/payment/add'))
const ClosuresPaymentPrint       = lazy(() => import('../../views/closures/payment/print'))
const ClosuresPaymentPreview     = lazy(() => import('../../views/closures/payment/preview'))
const ClosuresPaymentPreviewPage = lazy(() => import('../../views/closures/payment/previewpage'))

const ClosuresPayment = [
  {
    path: '/closures/Payment/list',
    element: <ClosuresPaymentList />
  },
  {
    path: '/closures/Payment/add/:id',
    element: <ClosuresPaymentAdd />
  },
  {
    path: '/closures/Payment/print/:id',
    element: <ClosuresPaymentPrint />
  },
  {
    path: '/closures/Payment/preview/:id',
    element: <ClosuresPaymentPreview />
  },
  {
    path : '/closures/Payment/previewpage/:id/:idf',
    element: <ClosuresPaymentPreviewPage />
  }
]

export default ClosuresPayment
